import { EventStatusId, IncidentId } from '@collector/sportsapi-client-legacy'

import { BlockingStrategy, ConfirmingStrategy } from './types'

export type EventRelatedStatusValue<I extends IncidentId = IncidentId> =
  | I
  | {
      incidentId: I
      description?: string
      blockingStrategy?: BlockingStrategy
      confirmingStrategy?: ConfirmingStrategy
    }

export type EventRelatedStatuses<I extends IncidentId = IncidentId> = {
  possibleNextStatusIncidents: EventRelatedStatusValue<I>[]
  otherStatusIncidents: EventRelatedStatusValue<I>[]
}

export type EventRelatedStatusConfig<
  E extends EventStatusId = EventStatusId,
  I extends IncidentId = IncidentId,
> = {
  [K in E]?: EventRelatedStatuses<I>
}

export const FINISHED_DESCRIPTION = 'Click if match is finished'

export const FINISHED_AFTER_EXTRA_INNING_DESCRIPTION =
  'Click if you are sure that match is finished after extra inning'

export const WAITING_FOR_EXTRATIME_DESCRIPTION = 'Click if extratime is next'

export const WAITING_FOR_PENALTY_DESCRIPTION =
  'Click if penalty shootout is next'
